module.exports = __webpack_public_path__ + "84940ce4b311e8e20100e5a8bbf21ff2.svg";